<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<!-- <v-btn icon @click="onSave" >
					<v-icon>mdi-content-save</v-icon>
				</v-btn> -->

				<!-- <v-divider vertical></v-divider> -->

				<!-- <v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn> -->
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-row>
						<v-col cols="12" md="2">
							<v-card class="my-2" flat>
								<v-card-text>
									<v-row>
										<v-col cols="12">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.name') | capitalize"
												v-model="item.name"
												clearable
												outlined
												dense
												hide-details="auto"
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col cols="12">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.code') | capitalize"
												v-model="item.code"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12">
											<v-textarea
												v-model="item.description"
												:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
												hint=""
												rows="2"
												outlined
												dense
												hide-details="auto"
											></v-textarea>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>

							<v-divider></v-divider>

							<v-card class="my-2" flat v-if="vehicles.length">
								<v-toolbar flat>
									 <v-app-bar-nav-icon>
										<v-icon>mdi-ruler-square-compass</v-icon>
									</v-app-bar-nav-icon>
									<v-toolbar-title>Оцінки</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn @click="onEstimate">
										<v-icon left>mdi-plus</v-icon>
										Створити
									</v-btn>

									<!-- <z-dialog-estimate :park="item" @ok="addEstimate" tooltip="create">
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
												<v-icon left>mdi-plus</v-icon>
												Створити
											</v-btn>
										</template>
									</z-dialog-estimate> -->
								</v-toolbar>

								<v-card-text>
									<v-list two-line>
										<v-list-item v-for="(item, index) in estimates" :key="index">
											<v-list-item-avatar :color="item.type.color">
												<v-icon v-text="item.type.icon" dark></v-icon>
											</v-list-item-avatar>
											<v-list-item-content>
												<v-list-item-title v-text="item.name"></v-list-item-title>
												<v-list-item-subtitle class="text--primary">{{ item.date | formatDate }}</v-list-item-subtitle>
												<v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
											</v-list-item-content>
											<v-list-item-action>
												<v-menu offset-y>
													<template v-slot:activator="{ on, attrs }">
														<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
													</template>
													<v-list>
														<z-dialog-detail-estimate :selected="item">
															<template v-slot:activator="props">
																<!-- <v-icon class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">mdi-eye</v-icon> -->
																<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog }">
																	<v-list-item-icon>
																		<v-icon>mdi-eye</v-icon>
																	</v-list-item-icon>
																	<v-list-item-content>
																		<v-list-item-title>Перегляд</v-list-item-title>
																	</v-list-item-content>
																</v-list-item>
															</template>
														</z-dialog-detail-estimate>

														<v-divider></v-divider>

														<v-list-item  @click="onPDFEstimate(item)">
															<v-list-item-icon>
																<v-icon color="#F40F02">mdi-file-pdf-box</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>PDF</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
														<v-list-item  @click="onExcelEstimate(item)">
															<v-list-item-icon>
																<v-icon color="#1D6F42">mdi-microsoft-excel</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title>Excel</v-list-item-title>
															</v-list-item-content>
														</v-list-item>

														<v-divider></v-divider>
														
														<z-confirm-delete @ok="onDeleteEstimate(item)">
															<template v-slot:activator="props">
																<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
																	<v-list-item-icon>
																		<v-icon>mdi-delete</v-icon>
																	</v-list-item-icon>
																	<v-list-item-content>
																		<v-list-item-title>Видалити</v-list-item-title>
																	</v-list-item-content>
																</v-list-item>
															</template>
														</z-confirm-delete>
													</v-list>
												</v-menu>
											</v-list-item-action>
										</v-list-item>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>

						<v-divider vertical></v-divider>

						<v-col cols="12" md="10">
							<v-card class="my-2" flat>
								<v-toolbar flat>
									<v-app-bar-nav-icon>
										<v-icon>mdi-car</v-icon>
									</v-app-bar-nav-icon>
									<v-toolbar-title>Транспортні засоби</v-toolbar-title>
									<v-spacer></v-spacer>

									<!-- <v-btn @click="onIdentification" class="mx-1" v-if="vehicles.length">
										<v-icon left>mdi-car-search</v-icon>
										Ідентифікація
										<v-icon right>mdi-menu-down</v-icon>
									</v-btn> -->
									<v-menu offset-y  v-if="vehicles.length">
										<template v-slot:activator="{ on, attrs }">
											<!-- <v-btn v-bind="attrs" v-on="on" @click="onIdentification" class="mx-1"> -->
											<v-btn v-bind="attrs" v-on="on" class="mx-1">
												<v-icon left>mdi-car-search</v-icon>
												Ідентифікація
												<v-icon right>mdi-menu-down</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item @click="onIdentification(null, 'number')">
												<v-list-item-icon>
													<v-icon>mdi-alpha-n-box</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>За номером</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item @click="onIdentification(null, 'vin')">
												<v-list-item-icon>
													<v-icon>mdi-alpha-v-box</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>За VIN-кодом</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>

									<!-- <v-divider vertical></v-divider> -->

									<v-btn @click="onExport" class="mx-1" v-if="vehicles.length">
										<v-icon left>mdi-export</v-icon>
										Експорт
									</v-btn>

									<z-import-excel 
										accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
										:headers="ie.headers"
										@ok="addVehicles"
									>
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}" class="mx-1">
												<v-icon left>mdi-import</v-icon>
												Імпорт
											</v-btn>
										</template>
									</z-import-excel>

									<!-- <v-divider vertical inset></v-divider> -->

									<!-- <v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" @click="onDeleteVehicleSelected" :disabled="!select.vehicles.length">
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</template>
										<span>Видалити</span>
									</v-tooltip> -->

									<z-detail-vehicle @add="addVehicle">
										<template v-slot:activator="props">
											<v-btn v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}" class="mx-1">
												<v-icon left>mdi-plus</v-icon>
												Додати
											</v-btn>
										</template>
									</z-detail-vehicle>
								</v-toolbar>

								<v-card-text>
									<v-data-table
										v-model="select.vehicles"
										:items="vehicles"
										:headers="header.vehicles"
										hide-default-footer
										:items-per-page="-1"
									>
										<template v-slot:[`item.avgPriceUAH`]="{ item }">
											<span>{{ item.avgPriceUAH | toCurrencyUAH }}</span>
										</template>
										<template v-slot:[`item.avgPriceUSD`]="{ item }">
											<span>{{ item.avgPriceUSD | toCurrencyUSD }}</span>
										</template>
										<template v-slot:item.actions="{ item, index }">
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
													<v-icon class="mx-3" v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
												</template>
												<v-list>
													<z-detail-vehicle v-model="item" @edit="editVehicle(item, $event)">
														<template v-slot:activator="props">
															<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
																<v-list-item-icon>
																	<v-icon>mdi-pencil</v-icon>
																</v-list-item-icon>
																<v-list-item-content>
																	<v-list-item-title>Редагувати</v-list-item-title>
																</v-list-item-content>
															</v-list-item>
														</template>
													</z-detail-vehicle>
													
													<v-divider></v-divider>

													<v-subheader>Ідентифікація</v-subheader>
													<v-list-item @click="onIdentification(item, 'number')">
														<v-list-item-icon>
															<v-icon>mdi-alpha-n-box</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title>За номером</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-list-item @click="onIdentification(item, 'vin')">
														<v-list-item-icon>
															<v-icon>mdi-alpha-v-box</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title>За VIN-кодом</v-list-item-title>
														</v-list-item-content>
													</v-list-item>

													<v-divider></v-divider>

													<z-confirm-delete @ok="onDeleteVehicle(item)">
														<template v-slot:activator="props">
															<v-list-item v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
																<v-list-item-icon>
																	<v-icon>mdi-delete</v-icon>
																</v-list-item-icon>
																<v-list-item-content>
																	<v-list-item-title>Видалити</v-list-item-title>
																</v-list-item-content>
															</v-list-item>
														</template>
													</z-confirm-delete>
												</v-list>
											</v-menu>
										</template>
										<template v-slot:body.append>
											<tr>
												<td colspan="9"><strong>Всього</strong></td>
												<td class="text-right" v-if="!isNaN(calculateTotalUAH())">{{ calculateTotalUAH() | toCurrencyUAH }}</td>
												<td class="text-right" v-if="!isNaN(calculateTotalUSD())">{{ calculateTotalUSD() | toCurrencyUSD }}</td>
											</tr>
										</template>
										<template v-slot:no-data>
											<i>Транспортні засоби відсутні. </i>
										</template>
										
									</v-data-table>
								</v-card-text>
							</v-card>						
						</v-col>
						
						<!-- <v-divider vertical></v-divider> -->

					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-file-input class="d-none" ref="fileinput" v-model="file" @change="changeFile"></v-file-input>

		<z-pdf-estimate ref="pdfEstimate" :item="itemPdf"></z-pdf-estimate>

		<z-dialog-estimate ref="dialogEstimate" :park="item" @ok="addEstimate" tooltip="create">
			<template v-slot:activator="props"></template>
		</z-dialog-estimate>

	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDetailVehicle from '@/views/dialogs/details/VehicleRequest'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zDialogDetailEstimate from '@/views/dialogs/details/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete2'
import zImportExcel from '@/views/components/dialogs/Import'
import zPdfEstimate from '@/views/pdf/VehicleParkEstimate'

import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'DialogDetailVehiclePark',
	mixins: [mixin],
	components: { zDetailVehicle, zDialogEstimate, zDialogDetailEstimate, zConfirmDelete, zImportExcel, zPdfEstimate },
	data: () => ({
		file: null,
		tab: null,
		tabs: ['Головна', 'Транспортні засоби', 'Оцінки'],

		header: {
			vehicles: [
				{ text: 'ID', value: 'id', sortable: true, width: '50'},
				{ text: 'Номер', value: 'number', sortable: true},
				{ text: 'VIN', value: 'vin', sortable: true},
				{ text: 'Марка', value: 'brand.name', sortable: true},
				{ text: 'Модель', value: 'model.name', sortable: true},
				{ text: 'Рік випуску', value: 'yearProd', sortable: true, align: 'center'},
				//{ text: 'Тип приводу', value: 'driver.name', sortable: true},
				{ text: "Об'єм двигуна, л", value: 'engineVolume', sortable: true},
				{ text: 'Тип палива', value: 'fuel.name', sortable: true},
				//{ text: 'Коробка передач', value: 'gearbox.name', sortable: true},
				{ text: 'Колір', value: 'color.name', sortable: true},
				//{ text: 'Показник одометра', value: 'odometer', sortable: true},
				{ text: 'Середня ціна, UAH', value: 'avgPriceUAH', sortable: true, align: 'end'},
				{ text: 'Середня ціна, USD', value: 'avgPriceUSD', sortable: true, align: 'end'},
				//{ text: '', value: 'actions', sortable: false, width: '10%', align: 'end' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
			estimates: [
				{ text: 'ID', value: 'id', sortable: true, width: '50'},
				{ text: 'Дата', value: 'date', sortable: true},
				//{ text: 'Код', value: 'code', sortable: true},
				{ text: 'Назва', value: 'name', sortable: true},
				//{ text: 'Опис', value: 'description', sortable: true},
				{ text: 'Тип', value: 'type.name', sortable: true},
				{ text: 'Середня ціна, UAH', value: 'avgPriceUAH', sortable: true},
				{ text: 'Середня ціна, USD', value: 'avgPriceUSD', sortable: true},
				//{ text: 'Мінімальна ціна', value: 'minPriceUAH', sortable: true},
				//{ text: 'Середня ціна', value: 'avgPriceUAH', sortable: true},
				//{ text: 'Максимальна', value: 'maxPriceUAH', sortable: true},
				{ text: 'Користувач', value: 'user.name', sortable: true},
				{ text: '', value: 'actions', sortable: false, width: '10%' },
			],
		},

		ie: {
			headers: [
				//{ text: 'ID', value: 'id', column: { text: 'A', value: 1 }},
				{ text: 'Номер', value: 'number', column: { text: 'A', value: 1 }},
				{ text: 'VIN', value: 'vin', column: { text: 'B', value: 2 }},
				{ text: 'Марка', value: 'brand.name', column: { text: 'C', value: 3 }},
				{ text: 'Модель', value: 'model.name', column: { text: 'D', value: 4 }},
				{ text: 'Рік випуску', value: 'yearProd', column: { text: 'E', value: 5 }, type: 'int'},
				{ text: 'Тип приводу', value: 'driver.name', column: { text: 'F', value: 6 }},
				{ text: "Об'єм двигуна", value: 'engineVolume', column: { text: 'G', value: 7 }, type: 'float',
					getValue: (value) => { 
						return value > 1000 ? value / 1000 : value
					}
				},
				{ text: 'Тип палива', value: 'fuel.name', column: { text: 'H', value: 8 }},
				{ text: 'Коробка передач', value: 'gearbox.name', column: { text: 'I', value: 9 }},
				{ text: 'Колір', value: 'color.name', column: { text: 'J', value: 10 }},
				{ text: 'Показник одометра', value: 'odometer', column: { text: 'K', value: 11 }},
			],
		},

		select: {
			vehicles: [],
			estimates: [],
		},

		itemPdf: {},

		snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},
		/* loadings: {
			category: false,
			brand: false,
			model: false,
			year: false,
			type: false,
		}, */
	}),

	props: {
		title: 				{ type: String, default: 'Парк' },
		icon: 				{ type: String, default: 'mdi-car-2-plus' },
		maxWidth: 			{ type: Number, default: 800 },

		/* category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null }, */
	},

	computed: {
		...mapGetters('VehiclePark', [ 'item' ]),
		/* ...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),
		...mapGetters('VehicleInsuranceType', { insuranceTypes: 'items' }), */

		id() {
			return this.item?.id ? this.item.id : null
		},

		vehicles() {
			return this.item?.vehicles ? this.item.vehicles : this.$set(this.item, 'vehicles', [])
		},

		/* table_vehicles() {
			return this.vehicles.map((item, index) => ({
				...item,
				uniqueIndex: index,
			}));
		}, */

		estimates() {
			return this.item?.estimates ? this.item.estimates : this.$set(this.item, 'estimates', [])
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.fullscreen = true;

		//this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		//this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0]))
	},

	methods: {
		...mapActions('VehiclePark', [ 'find', 'create', 'update', 'setItem' ]),

		save() {
			//return this.id ? this.update(this.selected) : this.create();
			return this.id ? this.update(this.item) : this.create();
		},

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			this.setItem();
			if(this.selected?.id) {
				this.loading = true
				this.find(this.selected.id).finally(() => (this.loading = false));
			}
		},

		onSave() {
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					//this.dialog = false
					this.snackbar.text = 'Дані збережено'
					this.snackbar.visible = true
					this.snackbar.color = 'success'
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			}
		},

		onOK() {
			//console.log(this.$options.name, 'item', this.item)
			if(this.$refs.form.validate()) {
				this.loading = true
				//let p = this.id ? this.update(this.selected) : this.create();
				const p = this.save()
				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				});
			}
		},

		addVehicle(item) {
			//console.log(this.$options.name, 'item', item)

			this.vehicles.push(item);

			//console.log(this.$options.name, 'vehicles', this.vehicles)
		},

		addVehicles(items) {
			//console.log(this.$options.name, 'items', items)
			items.forEach((item) => {
				
				if(item?.engineVolume > 1000) {
					item.engineVolume = item.engineVolume / 1000
				}

				this.addVehicle(item);
			})
		},

		editVehicle(selected, item) {
			//console.log(this.$options.name, 'selected', selected)
			//console.log(this.$options.name, 'item', item)

			const index = this.vehicles.indexOf(selected)
			this.vehicles.splice(index, 1, item)
		},

		removeVehicle(data) {
			//console.log(this.$options.name, 'removeVehicle', 'data', data)
			const index = this.vehicles.indexOf(data)

			//const index = this.table_vehicles.indexOf(data)
			//const index = data.index

			//console.log(this.$options.name, 'removeVehicle', 'index', index)

			this.vehicles.splice(index, 1);
		},

		deleteVehicle(item) {
			let that = this
			return axios.delete(`/vehicle/request/${item.id}`).then(response => {
				//console.log(this.$options.name, 'deleteVehicle','response.data', response.data)
				that.removeVehicle(item)
			}, error => {
				//if()
				console.log(error)
			})
		},

		onDeleteVehicle(item) {
			if(item?.id) {
				this.deleteVehicle(item)
			} else {
				this.removeVehicle(item)
			}
		},

		onDeleteVehicleSelected() {
			this.select.vehicles.forEach((item) => {
				if(item?.id) {
					this.deleteVehicle(item)
				} else {
					this.removeVehicle(item)
				}
			})

			this.select.vehicles = []
		},

		onEstimate() {
			//console.log(this.$options.name, 'onEstimate')
			if(this.$refs.form.validate()) {
				this.loading = true
				const p = this.save()
				p.then(()=>{
					this.$refs.dialogEstimate.dialog = true;
				}).finally(() => {
					this.loading = false
				});
			} else {
				this.snackbar.text = "Не заповнені обов'язкові поля"
				this.snackbar.visible = true
				this.snackbar.color = 'error'
			}
		},

		addEstimate(item) {
			//console.log(this.$options.name, 'item', item)

			this.estimates.push(item);

			if(this.item?.id) {
				this.loading = true
				this.find(this.item.id).finally(() => (this.loading = false));
			}

			//console.log(this.$options.name, 'estimates', this.estimates)
		},

		removeEstimate(data) {
			//console.log(this.$options.name, 'removeVehicle', 'data', data)
			const index = this.estimates.indexOf(data)
			this.estimates.splice(index, 1);

			/* if(Array.isArray(data)) {
				data.forEach((item) => {
					const index = this.estimates.indexOf(item)
					this.estimates.splice(index, 1);
				})
			} else {
				const index = this.estimates.indexOf(data)
				this.estimates.splice(index, 1);
			} */
		},

		deleteEstimate(item) {
			let that = this
			return axios.delete(`/vehicle/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'deleteEstimate','response.data', response.data)
				that.removeEstimate(item)
			}, error => {
				console.log(error)
			})
		},

		onDeleteEstimate(item) {
			let that = this

			if(item?.id) {
				this.loading = true
				this.deleteEstimate(item).finally(() => { this.loading = false });
			} else {
				this.removeEstimate(item)
			}
		},

		onImport() {
			this.file = null

			this.$refs.fileinput.$refs.input.click()
		},

		changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		},

		/**
		 * Обробка файлу
		 * @param file 
		 */
		processFile(file) {
			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processFile', 'XLSX', XLSX)

					let result = {}

					const bstr = e.target.result;
					const workbook = XLSX.read(bstr, { type: 'binary' });

					workbook.SheetNames.forEach((sheetName) => {
						//console.log(this.$options.name, 'processFile', 'sheetName', sheetName)
						//console.log(this.$options.name, 'processFile', 'sheet', sheet)

						const worksheet 	= workbook.Sheets[sheetName];
						const data_array 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

						//console.log(this.$options.name, 'processFile', 'data_array', data_array)
						data_array.forEach((data) => {
							let 
								brandName = data[1],
								modelName = data[2],
								yearProd = parseInt(data[3]),
								engineVolume = parseFloat(data[4])
							;


							if(!isNaN(yearProd) && !isNaN(engineVolume)) {
								this.vehicles.push({
									number: null,
									vin: null,
									brand: { name: brandName},
									model: { name: modelName},
									yearProd: yearProd,
									engineVolume: engineVolume > 1000 ? engineVolume / 1000 : engineVolume,
								})
							}
						})
					})

					//const ws = sheetName ? workbook.Sheets[sheetName] : workbook.Sheets[wb.SheetNames[s]]

					//const data_array 	= XLSX.utils.sheet_to_json(ws, { header: 1 });

					
					// Перетворення в об'єкт для відповіді
					/* if(this.workbook.hasOwnProperty('sheets')) {
						this.workbook.sheets.forEach((sheet, s) => {
							let type = sheet?.type ? sheet.type : 'Object'
								,sheetName = sheet?.name
							;

							//console.log(this.$options.name, 'changeImport', 'type', type)
							//console.log(this.$options.name, 'changeImport', 'sheetName', sheetName)

							let element = null
							switch(type){
								case 'Array': 	element = []; break;
								case 'Object': 	element = {}; break;
							}

							if(sheet?.element) {
								result[sheet.element] = element
							} else {
								element = result
							}

							const ws = sheetName ? wb.Sheets[sheetName] : wb.Sheets[wb.SheetNames[s]]

							const data_array 	= XLSX.utils.sheet_to_json(ws, { header: 1 });
							//const data_json 	= XLSX.utils.sheet_to_row_object_array(ws)

							//console.log(this.$options.name, 'changeImport', 'data_array', data_array)

							if(Array.isArray(element)) {
								data_array.forEach((row, r) => {
									if(r > 0) {
										let obj = {}
										sheet.headers.forEach((header, h) => {
											this.setValue(obj, header.value, row[h])
										})

										element.push(obj)
									}
								})
							} else {
								data_array.forEach((row, r) => {
									if(r > 0) {
										sheet.headers.forEach((header, h) => {
											this.setValue(element, header.value, row[h])
										})
									}
								})
							}
						})
					} */

					//console.log(this.$options.name, 'changeImport', 'result', result)

					//this.$emit('import', result)
				}

				//reader.readAsBinaryString(this.file);
				reader.readAsArrayBuffer(this.file);
			}
		},

		onExport() {
			//console.log(this.$options.name, 'onExport', 'vehicles', this.vehicles)

			const filename = 'park.xlsx';

			var opts = { bookType:"xlsx", bookSST:false, type:"array" };

			const workbook = XLSX.utils.book_new();

			const jsa = this.vehicles.map(item => {
				return {
					'Номер': item?.number,
					'VIN': item?.vin,
					'Марка': item?.brand?.name,
					'Модель': item?.model?.name,
					'Рік випуску': item?.yearProd,
					'Тип приводу': item?.driver?.name,
					"Об'єм двигуна, л": item?.engineVolume,
					'Тип палива': item?.fuel?.name,
					'Коробка передач': item?.gearbox?.name,
					'Колір': item?.color?.name,
					'Показник одометра': item?.odometer,
				};
			});

			const worksheet = XLSX.utils.json_to_sheet(jsa);

			XLSX.utils.book_append_sheet(workbook, worksheet, 'Vehicles');
			XLSX.writeFileXLSX(workbook, filename);
		},

		onPDFEstimate(item) {
			//console.log(this.$options.name, 'onPDFEstimate', 'item', item)
			let that = this
			this.loading = true
			axios.get(`/vehicle/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onPDFEstimate','response.data', response.data)
				that.itemPdf = response.data;
				that.$refs.pdfEstimate.generate();
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		onExcelEstimate(item) {
			//console.log(this.$options.name, 'onExcelEstimate', 'item', item)

			let that = this
			this.loading = true
			axios.get(`/vehicle/park/estimate/${item.id}`).then(response => {
				//console.log(this.$options.name, 'onExcelEstimate','response.data', response.data)

				let data = response.data;

				const filename = `Оцінка парку ${data.id}.xlsx`;

				var opts = { bookType:"xlsx", bookSST:false, type:"array" };

				const workbook = XLSX.utils.book_new();

				let main = {}
				if(data?.id) main['Ідентифікатор'] = data.id
				if(data?.code) main['Код'] = data.code
				if(data?.name) main['Назва'] = data.name
				if(data?.date) main['Дата'] = data.date
				if(data?.type?.name) main['Тип'] = data.type.name
				if(data?.user?.name) main['Користувач'] = data.user.name
				//if(data?.minPriceUAH) main['Вартість (мінімальна), UAH'] = data.minPriceUAH
				//if(data?.minPriceUSD) main['Вартість (мінімальна), USD'] = data.minPriceUSD
				if(data?.avgPriceUAH) main['Середня ціна, UAH'] = data.avgPriceUAH
				if(data?.avgPriceUSD) main['Середня ціна, USD'] = data.avgPriceUSD
				//if(data?.maxPriceUAH) main['Вартість (максимальна), UAH'] = data.maxPriceUAH
				//if(data?.maxPriceUSD) main['Вартість (максимальна), USD'] = data.maxPriceUSD

				//console.log(this.$options.name, 'onExcelEstimate', 'main', main)

				const worksheet = XLSX.utils.json_to_sheet([main]);

				const jsa = data.estimates.map(item => {
					return {
						'Номер': item?.request?.number,
						'VIN': item?.request?.vin,
						'Марка': item?.request?.brand?.name,
						'Модель': item?.request?.model?.name,
						'Рік випуску': item?.request?.yearProd,
						'Тип приводу': item?.request?.driver?.name,
						"Об'єм двигуна, л": item?.request?.engineVolume,
						'Тип палива': item?.request?.fuel?.name,
						'Коробка передач': item?.request?.gearbox?.name,
						'Колір': item?.request?.color?.name,
						'Показник одометра': item?.request?.odometer,
						//'Оціночна вартість (мінімальна), UAH': item.minPriceUAH,
						//'Оціночна вартість (мінімальна), USD': item.minPriceUAH,
						'Середня ціна, UAH': item.avgPriceUAH,
						'Середня ціна, USD': item.avgPriceUSD,
						//'Оціночна вартість (максимальна), UAH': item.maxPriceUAH,
						//'Оціночна вартість (максимальна), USD': item.maxPriceUSD,

					};
				});

				const worksheet2 = XLSX.utils.json_to_sheet(jsa);

				//console.log(this.$options.name, 'onExcelEstimate', 'jsa', jsa)

				XLSX.utils.book_append_sheet(workbook, worksheet, 'Оцінка');
				XLSX.utils.book_append_sheet(workbook, worksheet2, 'Транспортні засоби');
				XLSX.writeFileXLSX(workbook, filename);
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		calculateTotalUAH() {
			const totalPrice = this.vehicles.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUAH, 0);
			return totalPrice
		},
		calculateTotalUSD() {
			const totalPrice = this.vehicles.reduce((accumulator, currentValue) => accumulator + currentValue.avgPriceUSD, 0);
			return totalPrice
		},

		onIdentification(item, field) {
			if(item) {
				this.identification(item, field)
			} else {
				this.vehicles.forEach((item, index) => this.identification(item, field))
			}

			/* this.vehicles.forEach((item, index) => {
				const vinnumber = item?.vin ? item.vin : item?.number;
				if(vinnumber) {
					this.identification(item)
				} else {
					console.log(this.$options.name, 'onIdentification', index, 'Ні номер, ні vin не визначено')
				}
			}) */
		},

		/**
		 * Ідентифікація ТЗ за номером або vin-кодом
		 * 
		 * @param item 
		 */
		identification(item, field) {
			//const vinnumber = item?.vin ? item.vin : item?.number;
			const vinnumber = item[field];
			if(!vinnumber) return;

			return axios.get(`/vehicle/identification/${vinnumber}`).then(response => {
				//console.log(this.$options.name, 'identification','response.data', response.data)
				if(response.data?.favorit) {
					if(response.data?.favorit?.number) item.number = response.data.favorit.number;
					if(response.data?.favorit?.vin) item.vin = response.data.favorit.vin;
					if(response.data?.favorit?.brand) item.brand = response.data.favorit.brand;
					if(response.data?.favorit?.model) item.model = response.data.favorit.model;
					if(response.data?.favorit?.yearProd) item.yearProd = response.data.favorit.yearProd;
					if(response.data?.favorit?.color) item.color = response.data.favorit.color;
					if(response.data?.favorit?.fuel) item.fuel = response.data.favorit.fuel;
					if(response.data?.favorit?.engineVolume) item.engineVolume = response.data.favorit.engineVolume;
				}
			}, error => {
				console.log(error)
			}).finally(() => { this.loading = false });
		},

		/* identification(item) {
			if(item) {
				axios.get(`/vehicle/identification/${item.id}`).then(response => {
					console.log(this.$options.name, 'identification','response.data', response.data)
					//const index = that.estimates.indexOf(item)
					//that.estimates.splice(index, 1);
				}, error => {
					console.log(error)
				}).finally(() => { this.loading = false });
			}
		}, */
	},
}
</script>